<template>
  <el-dialog v-adaptive title="身份列表" :visible.sync="dialogVisible" center width="60%" @close="$emit('cancel')" :close-on-click-modal="false" top="5vh">
    <div class="dialog-container">
      <div class="treeScroll">
        <div class="box-card-tree">
          <el-scrollbar>
            <el-tree accordion :data="treeList" :props="defaultProps" node-key="ID" @node-click="handleNodeClick" :expand-on-click-node="false" :default-expanded-keys="treeExpandData" />
          </el-scrollbar>
        </div>
      </div>
      <div class="box-card-table">
        <div class="filter-container">
          <el-input v-model.trim="Name" placeholder="名称" size="small" clearable @clear="getList(1)" @keyup.native.enter="getList(1)" />
          <el-button type="primary" icon="el-icon-search" size="small" @click="getList(1)">搜索</el-button>
        </div>
        <div>
          <el-table :key="1" :data="listData" v-loading="listLoading" element-loading-text="拼命加载中..." border fit highlight-current-row :stripe="true">
            <el-table-column label="序号" width="60" type="index" align="center" />
            <el-table-column label="名称" prop="Name" align="center" />
            <el-table-column label="权限" prop="Role" align="center" min-width="400" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <span>{{
                  row.Role.split(',')
                    .map((res) => $common.listToStr(roleList, res, 'Name', 'NameCn'))
                    .join('、')
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="120px" fixed="right">
              <template slot-scope="{ row }">
                <el-button size="mini" type="primary" @click="switchStatus(row.ID)">切换</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagePagination">
          <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getBgUserList, RoleSwitchover, RoleQuery, orgQuery, GetUserAllSettings } from '../../http/api';

export default {
  name: 'statusList',
  props: ['isShow'],
  data() {
    return {
      Name: '',
      listLoading: true,
      total: 1,
      listData: [],
      treeList: [],
      treeExpandData: [],
      dialogVisible: this.isShow,
      roleList: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        where: ``,
        orgId: '',
        order: 'ID asc',
        select: '',
      },
      defaultProps: { children: 'children', label: 'Title' },
    };
  },
  watch: {
    isShow: function (val, oldVal) {
      this.dialogVisible = val;
      if (val) {
        this.getList(1);
        this.OrgQuery();
        this.roleQuery();
      }
    },
  },
  methods: {
    getList(num) {
      this.listLoading = true;
      if (num === 1) this.listQuery.pageNum = 1;
      if (this.Name) {
        this.listQuery.where = "Name like '%" + this.Name + "%'";
      } else {
        this.listQuery.where = '';
      }
      if (this.OrgStructureId) this.listQuery.orgId = this.OrgStructureId;
      getBgUserList(this.listQuery)
        .then((res) => {
          this.listData = res.Data;
          this.total = res.TotalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    OrgQuery() {
      let dataParams = {
        order: 'order asc',
        select: 'ID,Order,OrgType,Title,ParentID,DepartmentType',
        where: '',
      };
      orgQuery(dataParams).then((res) => {
        this.orgList = res;
        this.treeList = this.listToTree(res);
        this.treeExpandData.push(this.treeList[0].ID);
      });
    },
    switchStatus(id) {
      RoleSwitchover({ userId: id }).then((res) => {
        GetUserAllSettings().then((column) => {
          localStorage.setItem('columnArr', JSON.stringify(column));
          localStorage.setItem('userInfo', JSON.stringify(res));
          this.$router.push('/layout/home');
          location.reload();
        });
      });
    },
    handleNodeClick(data) {
      this.OrgStructureId = data.ID;
      this.getList(1);
    },
    listToStr(list, value) {
      list = list.find((ele) => ele['Name'] === value);
      return list ? list['NameCn'] : '';
    },
    listToTree(oldArr) {
      oldArr.forEach((element) => {
        let parentId = element.ParentID;
        if (parentId !== null) {
          oldArr.forEach((ele) => {
            if (ele.ID === parentId) {
              //当内层循环的ID == 外层循环的ParentID时，需要往该内层id里建个children并push对应的数组；
              if (!ele.children) {
                ele.children = [];
              }
              ele.children.push(element);
            }
          });
        }
      });
      oldArr = oldArr.filter((ele) => ele.ParentID === null); //这一步是过滤，按树展开，将多余的数组剔除；
      return oldArr;
    },
    roleQuery() {
      // 获取权限列表
      RoleQuery({
        order: 'ID asc',
        select: 'ID,Name,NameCn,Sys',
        where: "Sys='BasicData'",
      }).then((res) => {
        this.roleList = res;
      });
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
.filter-container {
  :deep(.el-input) {
    width: 200px;
    margin-bottom: 10px;
  }
}
.dialog-container {
  display: flex;
  justify-content: space-around;
  padding: 25px 25px 30px;
  .treeScroll {
    width: 18%;
    .box-card-tree {
      padding-right: 5px;
      :deep(.el-scrollbar) {
        height: 620px;
      }
      :deep(.el-scrollbar__wrap) {
        overflow-x: auto;
      }
    }
  }
  .box-card-table {
    height: 620px;
    width: 82%;
    margin-left: 20px;
  }
}
</style>
